import { ValidationErrorResponseSchema } from '@mntn/api-contracts/_shared/error-responses'
import { initContract } from '@ts-rest/core'
import { AccessCheckQuerySchema, AccessCheckResponseSchema } from './schemas.ts'

const c = initContract()

export const accessContract = c.router(
  {
    check: c.query({
      method: 'GET',
      path: '/flight-deck/v1/access',
      description: 'Check advertiser access',
      query: AccessCheckQuerySchema,
      responses: AccessCheckResponseSchema,
    }),
  },
  {
    strictStatusCodes: true,
    commonResponses: {
      400: ValidationErrorResponseSchema,
    },
    metadata: { tags: ['Flight Deck'] },
  },
)

export type AccessContract = typeof accessContract
